// extracted by mini-css-extract-plugin
module.exports = {"table":"TemplatesTable_table__36cjv","totalColumnHeadCell":"TemplatesTable_totalColumnHeadCell__2ebjk"};